import * as React from "react";
import { useState, useEffect } from "react"
import PageContainerWide from "../core/PageContainerWide";
import Breadcrumbs from "../core/Breadcrumbs";
import { jfetch, toast } from "../../utils";
import { useParams } from "react-router-dom";
import Button from "../core/Button";
import QuoteSummary from "./QuoteSummary"
import QuoteForm from "./QuoteForm"
import Sticky from 'react-sticky-el';
import Modal from '../core/Modal'
import QuickAddProduct from './QuickAddProduct'
import QuickAddService from './QuickAddService'
import QuickAddCharge from './QuickAddCharge'
import useQuote from '../../hooks/useQuote'
import * as moment from "moment";
import Loader from "../core/Loader";
import useQuery from "../../hooks/useQuery";

interface IProps {
  userContext: any;
  services: any;
  products: any;
  charges: any;
  productCategories: any;
  serviceCategories: any;
  chargeCategories: any;
  projectServiceCategories: any;
  updateService: Function;
  updateProduct: Function;
  updateCharge: Function;
  company: string;
  contact: string;
  email: string;
  notes: string;
  sold: boolean;
  isHAAS: boolean;
  setCompany: Function;
  setContact: Function;
  setEmail: Function;
  setNotes: Function;
  setSold: Function;
  setHAAS: Function;
  servicesTotal: number;
  serviceProfit: number;
  productsTotal: number;
  productProfit: number;
  chargesTotal: number;
  chargeProfit: number;
  monthlyRevenue: number;
  monthlyProfit: number;
  dueAmount: number;
  monthlyExpense: number;
  setServices: Function;
  setProducts: Function;
  setCharges: Function;
  withHAAS: number;
  withoutHAAS: number;
  LLGM: number;
  modifier: number;
  setModifier: Function;
  burdenRate: number;
  billRate: number;
  ROI: number;
  setBurdenRate: Function;
  setBillRate: Function;
  setROI: Function;
  contractTerm: number;
  setContractTerm: Function;
  projectServices: any;
  setProjectServices: Function;
  updateProjectService: Function;
  projectHours: number;
  projectLaborRevenue: number;
  projectLaborExpense: number;
  chargesOnlyTotal: number;
}

function QuoteEdit(props: IProps) {
  const { calculator_id }: any = useParams();
  const { quote_id }: any = useParams();
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false)
  const [showImport, setShowImport] = useState(false);
  const [showDownload, setShowDownload] = useState(false)
  const [file, setFile] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [search, setSearch] = useState('')
  const [users, setUsers] = useState([])
  const [usersVisible, setUsersVisible] = useState([])
  const [user, setUser] = useState('')
  const [opportunities, setOpportunities] = useState(null)
  const [opportunity, setOpportunity] = useState('')
  const [modalLoading, setModalLoading] = useState(false)
  const [timeAgo, setTimeAgo] = useState('')
  const [oppsLoading, setOppsLoading] = useState(false)
  const [companySearch, setCompanySearch] = useState('')
  const [companies, setCompanies] = useState([])
  const [companyModalLoading, setCompanyModalLoading] = useState(false)
  const 
    { 
      showHistory, 
      setShowHistory, 
      history, 
      setHistory, 
      setSoldString,
      cwCompany,
      setCwCompany,
      cwId,
      setCwId,
      companyModal,
      setCompanyModal,
      quoteSubmitted,
      setQuoteSubmitted
    } = useQuote()
    let query = useQuery();

  useEffect(() => {
    // init set default services, products & charges
    jfetch.get(`/organizations/${props.userContext.org.id}/quote_calculator/quote_calculator/${calculator_id}/quotes/${quote_id}`)
    .then((resp) => {
      let quote = resp.quote
      props.setServices(resp.meta.sorted_services, false)
      props.setProducts(resp.meta.sorted_products)
      props.setCharges(resp.meta.sorted_charges)
      props.setProjectServices(resp.meta.sorted_project_services)
      props.setCompany(quote.company)
      props.setContact(quote.contact)
      props.setNotes(quote.notes)
      props.setEmail(quote.email)
      props.setSold(quote.sold)
      props.setHAAS(quote.is_haas)
      props.setModifier(quote.modifier)
      setCwCompany(quote.company_name)
      setCwId(quote.company_id)
      setTimeAgo(quote.last_updated)
      if(quote.sold == null){
        setSoldString('')
      }
      else{
        if(quote.sold){
          setSoldString('1')
        }
        else {
          setSoldString('0')
        }
      }
    })

    jfetch.get(`/organizations/${props.userContext.org.id}/quote_calculator/quote_calculator/${calculator_id}/quotes/${quote_id}/import`)
    .then((resp) => {
      setShowImport(resp.any_missing)
    })

    jfetch.get(`/organizations/${props.userContext.org.id}/quote_calculator/quote_calculator/${calculator_id}/quotes/${quote_id}/edit_history`)
    .then((resp) => {
      setHistory(resp.history)
    })   

    getUsers()

    
  }, [])



  useEffect(() => {
    const timer = setTimeout(() => {
      filter(search)
    }, 333)
    return () => clearTimeout(timer)
  }, [search])

  useEffect(() => {
    if (user != '') {
      setOppsLoading(true)
      setOpportunity('')
      let params:any = {userid: user}
      if(cwId != null){
        params.company_id = cwId
      }
      jfetch.get('/cw/opportunities', params)
      .then((resp) => {
        setOpportunities(resp.data)
        setOppsLoading(false)
      })
    }
  }, [user, cwId])



  function makePDF() {
    setLoading(true)
    setShowDownload(false)
    fetch(`https://pdf.chartec.net/pdf2.php?url=https://core.chartec.net/q/quote_pdf/${quote_id}?key=DiRedcjfwt3`)
      .then(response => response.json())
      .then(data => {
        setFile(data.file)
        setLoading(false)
        setShowDownload(true)
      });
  }

  function runImport() {
    setLoading2(true)
    jfetch
      .get(`/organizations/${props.userContext.org.id}/quote_calculator/quote_calculator/${calculator_id}/quotes/${quote_id}/run_import`)
      .then((resp) => {
        if (resp.imported) {
          toast.success("Import successful")
          setLoading2(false)
          setShowImport(false)
          window.location.reload()

        }
      })
  }

  function getUsers() {
    jfetch.get('/cw/users', { search: search })
      .then((resp) => {
        if( resp.hasOwnProperty('data') ){
          setUsers(resp.data)
          setUsersVisible(resp.data)
        }
      })
      .then(() => {
        setSearch(props.userContext.user.email)
      })
  }

  function filter(query) {
    if(query != ''){
      let u = [...users]
      let q = query.toLowerCase()
      u = u.filter( user => {
        if ('firstName' in user && 'lastName' in user) {
          const full_name = user.firstName.toLowerCase() + " " + user.lastName.toLowerCase()
          const email = user.primaryEmail.toLowerCase()
          return (email.includes(q) || full_name.includes(q))
        }
        else{
          return false
        }
      })
      setUsersVisible(u)
    }
    else{
      setUsersVisible([...users])
    }
  }

  async function uploadOpportunity() {
    setModalLoading(true)
    const resp = await fetch(`https://pdf.chartec.net/pdf2.php?url=https://core.chartec.net/q/quote_pdf/${quote_id}?key=DiRedcjfwt3`)
    const response = await resp.json()
    const file = response.file

    const resp2 = await fetch(`/cw/opportunity_file.json?opportunity_id=${opportunity}&file=${file}`)
    if (resp2?.status == 200) {
      setModalLoading(false)
      setShowModal(false)
      toast.success('summary pdf was uploaded')
    }
    else {
      setLoading(false)
      toast.error('error saving')
    }
  }

  function runCompanySearch(){
    setCompanyModalLoading(true)
    jfetch.get('/cw/companies', {q:companySearch})
    .then((resp) => {
      setCompanies(resp.data)
      setCompanyModalLoading(false)
    })
  }

  function saveCompany(){
    setCompanyModalLoading(true)
    jfetch
    .post(`/organizations/${props.userContext.org.id}/quote_calculator/quote_calculator/${calculator_id}/quotes/${quote_id}/set_company`, {
      company_name: cwCompany,
      company_id: cwId
    })
    .then((resp) => {
      setCompanyModalLoading(false)
      setCompanyModal(false)
      toast.success('Company Updated')
    })
  }


  let op = quoteSubmitted ? '0.5' : '1'


  return (
    <div className="quote-new" style={{opacity:op}}>
      <PageContainerWide>
        <Breadcrumbs
          crumbs={[
            {
              label: "Pricing Quote Dashboard",
              route: "/quote_calculator",
              routerLink: true,
            },
            {
              label: "Quotes",
              routerLink: true,
              route: `/quote_calculator/${calculator_id}/quotes/`
            },                 
            { label: `Edit Quote` },
          ]}
        />
        <div className="row">
          <div className="col-lg-12 text-right">
            <a style={{ cursor: 'pointer' }} onClick={() => setShowHistory(true)}>edited {timeAgo}</a>
          </div>
        </div>
        <div className="row">
          <QuoteForm
            services={props.services}
            products={props.products}
            charges={props.charges}
            productCategories={props.productCategories}
            serviceCategories={props.serviceCategories}
            chargeCategories={props.chargeCategories}
            projectServiceCategories={props.projectServiceCategories}
            updateService={props.updateService}
            updateProduct={props.updateProduct}
            updateCharge={props.updateCharge}
            company={props.company}
            contact={props.contact}
            email={props.email}
            notes={props.notes}
            sold={props.sold}
            isHAAS={props.isHAAS}
            setCompany={props.setCompany}
            setContact={props.setContact}
            setEmail={props.setEmail}
            setNotes={props.setNotes}
            setSold={props.setSold}
            setHAAS={props.setHAAS}
            userContext={props.userContext}
            burdenRate={props.burdenRate}
            billRate={props.billRate}
            ROI={props.ROI}
            setBurdenRate={props.setBurdenRate}
            setBillRate={props.setBillRate}
            setROI={props.setROI}
            contractTerm={props.contractTerm}
            setContractTerm={(val) => props.setContractTerm(val)}
            projectServices={props.projectServices}
            updateProjectService={props.updateProjectService}
            projectHours={props.projectHours}
            projectLaborRevenue={props.projectLaborRevenue}
            projectLaborExpense={props.projectLaborExpense}
            servicesTotal={props.servicesTotal}
            productsTotal={props.productsTotal}
            chargesTotal={props.chargesTotal}
            chargesOnlyTotal={props.chargesOnlyTotal}
            cwCompany={cwCompany}
            cwId={cwId}
          />
          <div className="col-lg-3">
            <Sticky>
              <div style={{ paddingTop: '67px' }}>
                <h4 style={{color:'black'}}>Quote: {props.company}</h4>
                <div className="row">
                  <div className="col-lg-12">
                    <QuoteSummary
                      servicesTotal={props.servicesTotal}
                      serviceProfit={props.serviceProfit}
                      productsTotal={props.productsTotal}
                      productProfit={props.productProfit}
                      chargesTotal={props.chargesTotal}
                      chargeProfit={props.chargeProfit}
                      monthlyRevenue={props.monthlyRevenue}
                      monthlyProfit={props.monthlyProfit}
                      dueAmount={props.dueAmount}
                      withHAAS={props.withHAAS}
                      withoutHAAS={props.withoutHAAS}
                      LLGM={props.LLGM}
                      modifier={props.modifier}
                      setModifier={props.setModifier}
                      burdenRate={props.burdenRate}
                      billRate={props.billRate}
                    />
                  </div>
                </div>
                <div className="row" style={{ paddingTop: '15px' }} >
                  <div className="col-lg-12 text-left">
                    <div style={{ display: 'flex', flexDirection: 'column', alignContent: 'center', flexWrap: 'wrap', minHeight: '166px', justifyContent: 'space-evenly' }}>
                      <Button
                        loading={quoteSubmitted}
                        color="primary"
                        onClick={() => {
                          setQuoteSubmitted(true)
                          let quote = {
                            quote: {
                              company: props.company,
                              contact: props.contact,
                              email: props.email,
                              notes: props.notes,
                              sold: props.sold,
                              services: props.services,
                              project_services: props.projectServices,
                              products: props.products,
                              charges: props.charges,
                              quote_calculator_quote_calculator_id: calculator_id,
                              monthly_revenue: props.monthlyRevenue,
                              monthly_expense: props.monthlyExpense,
                              monthly_profit: props.monthlyProfit,
                              service_profit: props.serviceProfit,
                              product_profit: props.productProfit,
                              charge_profit: props.chargeProfit,
                              amount_due: props.dueAmount,
                              is_haas: props.isHAAS,
                              modifier: props.modifier,
                              burden_rate: props.burdenRate,
                              bill_rate: props.billRate,
                              roi: props.ROI,
                              project_price: props.chargesTotal,
                              haas_price: props.withHAAS
                            }
                          }
                          jfetch.patch(`/organizations/${props.userContext.org.id}/quote_calculator/quote_calculator/${calculator_id}/quotes/${quote_id}`, quote)
                            .then((resp) => {
                              setQuoteSubmitted(false)
                              toast.success('Your quote was updated succesfully')
                            })
                            .catch((err) => {
                               setQuoteSubmitted(false)
                              // console.log('error: ', err)
                            })
                        }}
                      >
                        Update Quote
                      </Button>
                      {showImport && (
                        <Button color="primary" onClick={runImport} loading={loading2}>
                          Import New
                        </Button>
                      )}
                      <Button color="info" onClick={makePDF} loading={loading}>
                        Generate PDF
                      </Button>
                      {showDownload && (
                        <a className="btn btn-info" href={file} target="_blank" rel="noopener noreferrer">
                          Download PDF
                        </a>
                      )}
                      {(props.userContext.org.id == 21 || props.userContext.org.id == 71) && (
                        <Button color="info" onClick={() => setShowModal(true)}>
                          Submit to Opportunity
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Sticky>
          </div>
        </div>
        <Modal
          title={"Submit to Opportunity"}
          open={showModal}
          close={() => setShowModal(false)}
          submittable={true}
          isLarge={false}
          disallowClickOutside={true}
          submitText="upload"
          onSubmit={uploadOpportunity}
          isSubmitting={modalLoading}
          canSubmit={ opportunity != ''}
        >
          <div className="row">
            <div className="col-lg-9">
              <div className="form-group">
                <label>Filter</label>
                <input type="text" className="form-contro" value={search} placeholder="user@company.com..." onChange={(e) => setSearch(e.target.value)} />
              </div>
              <div>
                <h3>Users <small style={{color:'black'}}>{usersVisible.length} of {users.length}</small></h3>
                  <div className="cw-users-list" style={{display:'flex', flexWrap:'wrap', maxHeight:'300px', overflowY:'scroll'}}>
                    {usersVisible && usersVisible.map((u) => {
                      const border = u.id == user ? '1px solid green' : '1px solid #FFF';
                      return (
                        <div key={u.id} className="cw-user-row" style={{width:'100%', display:'flex', justifyContent: 'space-between', padding:'12px 10px', backgroundColor:'#e9e9e9bb', border:border}}>
                          <div>{u.firstName} {u.lastName} [{u.primaryEmail}]</div>
                          <button className="btn btn-sm btn-success" onClick={(e) => setUser(u.id)} style={{maxHeight:'30px'}}>Select User</button>
                        </div>
                      )
                    })}
                  </div>
              </div>
              <div className="form-group" style={{paddingTop:'20px'}}>
                { oppsLoading && (
                  <Loader />
                )}
                { !oppsLoading && opportunities && opportunities.length < 1 && <p>No Opportunites found for this user</p>}
                { !oppsLoading && opportunities && opportunities.length > 0 && (
                  <>
                  <label>Select Opportunity</label>
                  <select className="form-control" value={opportunity} onChange={(e) => setOpportunity(e.target.value)}>
                    <option value=''>Select One</option>
                    {opportunities.map((op) => {
                      return (
                        <option value={op.id} key={op.id}>{op.name}</option>
                      )
                    })}
                  </select>     
                  </>             
                )}
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          title={"Select a Company"}
          open={companyModal}
          close={() => setCompanyModal(false)}
          submittable={true}
          isLarge={false}
          disallowClickOutside={true}
          submitText="Save"
          onSubmit={saveCompany}
          isSubmitting={companyModalLoading}
          canSubmit={ cwId != null}
        >
          <div className="row">
            <div className="col-lg-9">
              <div className="form-group">
                <label>Search ConnectWise Companies</label>
                <input type="text" className="form-contro" value={companySearch} placeholder="Company Name.." onChange={(e) => setCompanySearch(e.target.value)} />
                <button className="btn btn-primary" onClick={runCompanySearch} disabled={companyModalLoading}>Search</button>
              </div>
              <div>
                <h3>Companies <small style={{color:'black'}}>{companies.length} found</small></h3>
                  <div className="cw-users-list" style={{display:'flex', flexWrap:'wrap', maxHeight:'300px', overflowY:'scroll'}}>
                    { companies.map((c) => {
                      const border = c.id == cwId ? '1px solid green' : '1px solid #FFF';
                      return (
                        <div key={c.id} className="cw-user-row" style={{width:'100%', display:'flex', justifyContent: 'space-between', padding:'12px 10px', backgroundColor:'#e9e9e9bb', border:border}}>
                          <div>{c.name}</div>
                          <button 
                            className="btn btn-sm btn-success" 
                            style={{maxHeight:'30px'}}
                            onClick={(e) => {
                              setCwId(c.id)
                              setCwCompany(c.name)
                            }} 
                          >
                            Select Company
                          </button>
                        </div>
                      )
                    })}
                  </div>
              </div>
            </div>
          </div>
        </Modal>        
        <Modal
          title={"Edit History"}
          open={showHistory}
          close={() => setShowHistory(false)}
          submittable={false}
          isLarge={false}
          disallowClickOutside={true}
        >
          <div className="row">
            <div className="col-lg-12">
              <table className="table">
                <tr>
                  <th>User</th>
                  <th>Edit Date</th>
                </tr>
                {history.map((edit) => {
                  const updated_moment = moment(edit.time).fromNow();
                  return (
                    <tr key={edit.id}>
                      <td>{edit.properties.user_name}</td>
                      <td>{updated_moment}</td>
                    </tr>
                  )
                })}
              </table>

            </div>
          </div>
        </Modal>
        <QuickAddProduct productCategories={props.productCategories} setProducts={props.setProducts} />
        <QuickAddService serviceCategories={props.serviceCategories} setServices={props.setServices} />
        <QuickAddCharge chargeCategories={props.chargeCategories} setCharges={props.setCharges} />
      </PageContainerWide>
    </div>
  )
}

export default QuoteEdit


// WEBPACK FOOTER //
// ./app/javascript/components/quote_calculator/QuoteEdit.tsx